import { Component, Input, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { SupportTicketService } from '../Model/Support/support-ticket.service';
import { CommonService } from '../Model/Common/common.service';
import { SessionService } from '../Util/Session/session.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../Model/utility/utility.service';
import { ToastService } from '../Util/Toast/toast.service';
import { ComboService } from '../Model/Combo/combo.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-client-request-history',
  standalone: true,
  imports: [LoaderComponent, DataTablesModule, CommonModule],
  templateUrl: './client-request-history.component.html',
  styleUrl: './client-request-history.component.scss'
})
export class ClientRequestHistoryComponent {

  isDisabled: boolean = false;
  SupportData: any = [];
  @Input() InputData: any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private support: SupportTicketService,
    protected common: CommonService,
    private sessionService: SessionService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private toast: ToastService,
    private combo: ComboService,
    public activeModal: NgbActiveModal,
  ) {
    //this.User = this.sessionService.GetUserDetails();
    // this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }
  ngOnInit() {
    this.getData();
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  Close() {
    this.activeModal.close();
  }

  getData() {
    this.SupportData = [];
    const Detail = {
      SelectType: 'History',
      ESS_ClientPortalHelpDeskRequestId: this.InputData.ESS_ClientPortalHelpDeskRequestId,
      ClientPortalHelpDeskUserType: 'Admin'
    }
    this.isDisabled = true;
    this.support.ClientPortal_HelpDeskRequest(Detail).subscribe({
      next: (data) => {
        this.SupportData = Object.values(data.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }
  
  Link(Text: string) {
    window.open(this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'ClientPortalHelpdesk' + '/' + Text, "_blank");
  }
}
